const BAND_CFG = {
  excellent: { color: "#10B981", label: "Excellent" },
  good:      { color: "#06B6D4", label: "Good" },
  fair:      { color: "#F59E0B", label: "Fair" },
  attention: { color: "#F97316", label: "Attention" },
  action:    { color: "#F43F5E", label: "Action Required" },
};

export function HealthScoreGauge({ score = 0, band = "fair", size = 180 }) {
  const cfg = BAND_CFG[band] || BAND_CFG.fair;
  const r = size / 2 - 12;
  const c = 2 * Math.PI * r;
  const dash = (c * Math.min(100, Math.max(0, score))) / 100;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="#E2E8F0" strokeWidth="10" />
        <circle
          cx={size/2} cy={size/2} r={r} fill="none"
          stroke={cfg.color} strokeWidth="10" strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          style={{ transition: "stroke-dasharray 1.2s cubic-bezier(.16,1,.3,1)" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-display font-bold text-4xl text-slate-900">{score}</div>
        <div className="text-[10px] uppercase tracking-[0.18em] font-bold mt-0.5" style={{ color: cfg.color }}>
          {cfg.label}
        </div>
      </div>
    </div>
  );
}

export { BAND_CFG };
